module.exports = __webpack_public_path__ + "img/logo-funda-white.bf3da26e.svg";